import Context from 'app/consts/context';

import React, { useContext, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const ProviderRoot: React.FC = () => {
  const { setSiteVersion } = useContext(Context);

  useEffect(() => {
    setSiteVersion('providers', false);
  });

  return (
    <>
      <Helmet titleTemplate="Galatea Bio - Providers - %s" />
      <Outlet />
    </>
  );
};

export default ProviderRoot;
